import AdminRootLayout from "./AdminRootLayout";

export default AdminRootLayout;
